// extracted by mini-css-extract-plugin
export default {"content":"Content_content__AlgpM","center":"Content_center__uiIgB"};